import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useRegisterStore = defineStore("pageRegister", () => {
  const language = ref<string>("en");
  const selectedPlatform = ref();

  const name = ref<string>("");
  const email = ref<string>("");
  const phoneNumber = ref<string>("");
  const shopUrl = ref<string>("");
  const captcha = ref<string>("");

  const formValidationErrors = ref({
    isValidating: false,
    name: "",
    email: "",
    phoneNumber: "",
    shopUrl: "",
    captcha: "",
  });

  const formValidationErrorsBackend = ref({
    email: "",
    shopUrl: "",
    captcha: "",
  });

  const isFormValid = computed(
    () =>
      !formValidationErrors.value.name &&
      !formValidationErrors.value.email &&
      !formValidationErrors.value.phoneNumber &&
      !formValidationErrors.value.shopUrl &&
      !formValidationErrorsBackend.value.email &&
      !formValidationErrorsBackend.value.shopUrl
  );

  return {
    language,
    selectedPlatform,
    name,
    email,
    phoneNumber,
    shopUrl,
    captcha,
    formValidationErrors,
    formValidationErrorsBackend,
    isFormValid,
  };
});
